import moment from 'moment-mini';

export const WORK_SCHEDULE_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function formatWorkScheduleTime(timeOfDay = {}) {
  const rawHour = Number(timeOfDay?.hour);
  const rawMinute = Number(timeOfDay?.minute);
  const hour = Number.isFinite(rawHour) ? Math.min(23, Math.max(0, Math.trunc(rawHour))) : 8;
  const minute = Number.isFinite(rawMinute) ? Math.min(59, Math.max(0, Math.trunc(rawMinute))) : 0;
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${String(minute).padStart(2, '0')} ${period}`;
}

/** A human-readable cadence for schedule cards and form previews. */
export function describeWorkSchedule(value = {}) {
  const schedule = value?.schedule || value;
  const time = formatWorkScheduleTime(schedule?.timeOfDay);

  switch (schedule?.type) {
    case 'once': {
      const runAt = moment(schedule?.runAt);
      return schedule?.runAt && runAt.isValid()
        ? `Once · ${runAt.format('MMM D')} at ${runAt.format('h:mm A')}`
        : 'Runs once';
    }
    case 'weekly': {
      const days = (Array.isArray(schedule?.daysOfWeek) ? schedule.daysOfWeek : [])
        .map((day) => WORK_SCHEDULE_DAYS[Number(day)])
        .filter(Boolean);
      return `Every ${days.join(', ') || 'Mon'} at ${time}`;
    }
    case 'monthly': {
      const day = Math.min(31, Math.max(1, Math.trunc(Number(schedule?.dayOfMonth)) || 1));
      return `Monthly on day ${day} at ${time}`;
    }
    case 'annually': {
      const month = Math.min(12, Math.max(1, Number(schedule?.month) || 1));
      const day = Math.min(31, Math.max(1, Number(schedule?.dayOfMonth) || 1));
      return `Every year on ${moment().month(month - 1).format('MMM')} ${day} at ${time}`;
    }
    default:
      return `Every day at ${time}`;
  }
}
